import ApplicationAdapter from 'eflex/adapters/application';

export default class RestBomSourceAdapter extends ApplicationAdapter {
  pathForType() {
    return 'bomSources';
  }
}
